import { createReducer } from '../utils/misc';
import {
    FETCH_USERS_REQUEST,
    FETCH_USERS_FAILURE,
    FETCH_USERS_SUCCESS,
    CREATE_USER_REQUEST,
    CREATE_USER_FAILURE,
    CREATE_USER_SUCCESS,
    DELETE_USER_SUCCESS,
    DELETE_USER_REQUEST,
    DELETE_USER_FAILURE,
    VIEW_USER_SUCCESS,
    VIEW_USER_REQUEST,
    VIEW_USER_FAILURE,
    VIEW_USER_FILES_SUCCESS,
    VIEW_USER_FILES_REQUEST,
    VIEW_USER_FILES_FAILURE,
    UPLOAD_USER_FILE_SUCCESS,
    UPLOAD_USER_FILE_REQUEST,
    UPLOAD_USER_FILE_FAILURE,
    DOWNLOAD_FILE_SUCCESS,
    DOWNLOAD_FILE_REQUEST,
    DOWNLOAD_FILE_FAILURE,
    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAILURE,
    CHANGE_PASSWORD_REQUEST,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE,
    DELETE_FILE_REQUEST,
    DELETE_FILE_SUCCESS,
    DELETE_FILE_FAILURE,
} from '../constants/index';

const initialState = {
    data: [],
    files: [],
    user: null,
    url: null,
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isDownloading: false,
    loaded: false,
    statusText: null,
    action: null,
};

export default createReducer(initialState, {
    [FETCH_USERS_REQUEST]: (state) =>
        Object.assign({}, state, {
            isFetching: true,
            action: FETCH_USERS_REQUEST,
        }),
    [FETCH_USERS_SUCCESS]: (state, payload) =>
        Object.assign({}, state, {
            data: payload.data,
            isFetching: false,
            loaded: true,
            action: FETCH_USERS_SUCCESS,
            statusText: null,
        }),
    [FETCH_USERS_FAILURE]: (state) =>
        Object.assign({}, state, {
            isFetching: false,
            loaded: true,
            statusText: 'Failed to load users',
            action: FETCH_USERS_FAILURE,
        }),
    [CREATE_USER_REQUEST]: (state) =>
        Object.assign({}, state, {
            isCreating: true,
            action: CREATE_USER_REQUEST,
        }),
    [CREATE_USER_SUCCESS]: (state, payload) =>
        Object.assign({}, state, {
            user: payload,
            isCreating: false,
            action: CREATE_USER_SUCCESS,
            statusText: null,
        }),
    [CREATE_USER_FAILURE]: (state, payload) =>
        Object.assign({}, state, {
            isCreating: false,
            statusText: `${payload.status} ${payload.statusText}`,
            action: CREATE_USER_FAILURE,
        }),
    [UPDATE_USER_REQUEST]: (state) =>
        Object.assign({}, state, {
            action: UPDATE_USER_REQUEST,
        }),
    [UPDATE_USER_SUCCESS]: (state) =>
        Object.assign({}, state, {
            action: UPDATE_USER_SUCCESS,
            statusText: null,
        }),
    [UPDATE_USER_FAILURE]: (state, payload) =>
        Object.assign({}, state, {
            statusText: `${payload.status} ${payload.statusText}`,
            action: UPDATE_USER_FAILURE,
        }),
    [CHANGE_PASSWORD_REQUEST]: (state) =>
        Object.assign({}, state, {
            action: CHANGE_PASSWORD_REQUEST,
        }),
    [CHANGE_PASSWORD_SUCCESS]: (state) =>
        Object.assign({}, state, {
            action: CHANGE_PASSWORD_SUCCESS,
            statusText: null,
        }),
    [CHANGE_PASSWORD_FAILURE]: (state, payload) =>
        Object.assign({}, state, {
            statusText: `${payload.statusText}`,
            action: CHANGE_PASSWORD_FAILURE,
        }),
    [DELETE_USER_REQUEST]: (state) =>
        Object.assign({}, state, {
            isDeleting: true,
            action: DELETE_USER_REQUEST,
        }),
    [DELETE_USER_SUCCESS]: (state, payload) =>
        Object.assign({}, state, {
            isDeleting: false,
            action: DELETE_USER_SUCCESS,
            statusText: null,
        }),
    [DELETE_USER_FAILURE]: (state, payload) =>
        Object.assign({}, state, {
            isDeleting: false,
            statusText: `${payload.status} ${payload.statusText}`,
            action: DELETE_USER_FAILURE,
        }),
    [VIEW_USER_REQUEST]: (state) =>
        Object.assign({}, state, {
            isFetching: true,
            action: VIEW_USER_REQUEST,
        }),
    [VIEW_USER_SUCCESS]: (state, payload) =>
        Object.assign({}, state, {
            isFetching: false,
            user: payload.user,
            action: VIEW_USER_SUCCESS,
            statusText: null,
        }),
    [VIEW_USER_FAILURE]: (state, payload) =>
        Object.assign({}, state, {
            isFetching: false,
            statusText: `${payload.status} ${payload.statusText}`,
            action: VIEW_USER_FAILURE,
        }),  
    [VIEW_USER_FILES_REQUEST]: (state) =>
        Object.assign({}, state, {
            isFetching: true,
            action: VIEW_USER_FILES_REQUEST,
        }),
    [VIEW_USER_FILES_SUCCESS]: (state, payload) =>
        Object.assign({}, state, {
            isFetching: false,
            files: payload.files,
            action: VIEW_USER_FILES_SUCCESS,
            statusText: null,
        }),
    [VIEW_USER_FILES_FAILURE]: (state, payload) =>
        Object.assign({}, state, {
            isFetching: false,
            statusText: `${payload.status} ${payload.statusText}`,
            action: VIEW_USER_FILES_FAILURE,
        }),  
    [UPLOAD_USER_FILE_REQUEST]: (state) =>
        Object.assign({}, state, {
            isUploading: true,
            action: UPLOAD_USER_FILE_REQUEST,
        }),
    [UPLOAD_USER_FILE_SUCCESS]: (state) =>
        Object.assign({}, state, {
            isUploading: false,
            action: UPLOAD_USER_FILE_SUCCESS,
            statusText: null,
        }),
    [UPLOAD_USER_FILE_FAILURE]: (state, payload) =>
        Object.assign({}, state, {
            isUploading: true,
            statusText: `${payload.status} ${payload.statusText}`,
            action: UPLOAD_USER_FILE_FAILURE,
        }),
    [DOWNLOAD_FILE_REQUEST]: (state) =>
        Object.assign({}, state, {
            isDownloading: true,
            action: DOWNLOAD_FILE_REQUEST,
        }),
    [DOWNLOAD_FILE_SUCCESS]: (state, payload) =>
        Object.assign({}, state, {
            isDownloading: false,
            url: payload.url.url,
            action: DOWNLOAD_FILE_SUCCESS,
            statusText: null,
        }),
    [DOWNLOAD_FILE_FAILURE]: (state, payload) =>
        Object.assign({}, state, {
            isDownloading: true,
            statusText: `${payload.status} ${payload.statusText}`,
            action: DOWNLOAD_FILE_FAILURE,
        }),
    [DELETE_FILE_REQUEST]: (state) =>
        Object.assign({}, state, {
            action: DELETE_FILE_REQUEST,
        }),
    [DELETE_FILE_SUCCESS]: (state, payload) =>
        Object.assign({}, state, {
            action: DELETE_FILE_SUCCESS,
            statusText: null,
        }),
    [DELETE_FILE_FAILURE]: (state, payload) =>
        Object.assign({}, state, {
            statusText: `${payload.status} ${payload.statusText}`,
            action: DELETE_FILE_FAILURE,
        }),         
});



// WEBPACK FOOTER //
// ./src/reducers/user.js